import { Exclude, Expose, Transform, TransformFnParams, Type } from 'class-transformer';

import { StorageUploadLinkFields } from '../model';
import { BaseModel } from '@core/data-access';
import { Default } from '@core/util';

@Exclude()
export class StorageUploadLinkDto extends BaseModel {
  @Expose() type!: string;
  @Expose() name!: string;
  @Expose() acl?: 'public-read';
}

@Exclude()
export class StoragePublicLinkDto extends BaseModel {
  @Expose() keyName!: string;
}

@Expose()
export class StorageUploadFileDto extends BaseModel {
  @Expose() url!: string;

  @Expose() @Type(() => StorageUploadLinkFields) fields!: StorageUploadLinkFields;

  @Expose()
  @Type(() => Object)
  @Transform((params: TransformFnParams) => params.obj.file)
  file!: File;

  @Expose()
  @Type(() => Boolean)
  @Default(false)
  isPublic?: boolean;
}
